const res = {
  creation: {
    title: '創造(Creation)力とは？',
    strong: '新たな価値を生み出す',
    image: 'illust_05',
    text: '混迷する現代社会において、目の前の問題や課題を解決するためには、それまでの発想ややり方にとらわれずに、新しいものをつくりだす創造力を駆使することが求められます。福祉創造学科では、新たな価値を生み出す「創造力」を育むことができます。',
  },
  imagination: {
    title: '想像(Imagination)力とは？',
    strong: '相手の想いに共感する',
    image: 'illust_06',
    text: 'コミュニケーションは、社会生活を送る上であらゆる場面で求められます。コミュニケーションを行う上で大切なことは、人々の想いに目を向けることです。福祉創造学科では、相手の想いに共感する「想像力」を養うことができます。',
  },
};

export function modal() {
  const popup = document.getElementById('js-popup');
  const blackBg = document.getElementById('js-black-bg');
  const closeBtn = document.getElementById('js-close-btn');

  const showBtn = document.querySelectorAll('.js-show-btn');

  showBtn.forEach((e) => {
    e.addEventListener('click', function click() {
      closeModal();
      createContent(e.dataset.key);
    });
  });

  toggleModal(blackBg);
  toggleModal(closeBtn);

  // モーダルの開閉
  function toggleModal(e) {
    e.addEventListener('click', function click() {
      closeModal();
    });
  }

  function closeModal() {
    popup.classList.toggle('is-show');
  }

  function createContent(key) {
    const content = document.getElementById('js-content');

    while (content.firstChild) {
      content.removeChild(content.firstChild);
    }

    const html = `
      <p class="u-txt-16 u-lh-high u-ta-ce u-clr-midnightblue">
        ${res[key].title}<br /><span class="u-txt-18 u-fw-bold">${res[key].strong}</span>
      </p>
      <div class="c-container c-container--blk c-modal_container u-flxAi-ce u-mt-25">
        <div class="c-modal_image"><img src="./img/${res[key].image}.png"></div>
        <p class="c-modal_text u-txt-16 u-lh-high">${res[key].text}</p>
      </div>
    `;
    content.insertAdjacentHTML('afterbegin', html);
  }
}
